import React from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { Form, Input, Button, Select, Cascader, message, Tooltip, Icon, Row, Col } from "antd";

import { $util, $const } from "../../helper";
import Modal from "../modal/modal";
import CheckErrorInfo from "../common/checkErrorInfo";
import Language from "../language/language";
import SchoolsForm from "./schoolsForm/index";

import "./stylesheets/teamInfoEdit.scss";

const FormItem = Form.Item;
const Option = Select.Option;

@inject("authStore", "languageStore", "gameStore", "teamStore", "navStore", "commonStore")
@observer
@withRouter
class TeamInfoEdit extends React.Component {
  state = {
    chinaArea: [],
    teamInfo: null,
    recipientAddress: [],
    showCheckModal: false,
    checkErrorInfo: [],
    submitIsLoading: false
  };
  componentDidMount() {
    this.setState({
      teamInfo: this.props.teamInfo,
      chinaArea: this.props.commonStore.pca
    });
  }

  verify = async values => {
    if (!values) return false;
    const { delegateSchools } = values;
    const userId = this.props.authStore.user && this.props.authStore.user.id;
    const gameId = this.props.gameStore.selectedGame && this.props.gameStore.selectedGame.id;
    const teamId = this.props.teamStore.teamInfo && this.props.teamStore.teamInfo.id;
    const checkRes = await $util.verifyPersonalInfo(userId, gameId, teamId, "3", delegateSchools);
    if (checkRes && checkRes.data && checkRes.data.result === 1) {
      return true;
    }
    if (checkRes && checkRes.data && checkRes.data.res && checkRes.data.res.length > 0) {
      this.setState({
        checkErrorInfo: checkRes.data.res
      });
      return false;
    }
    return false;
  };

  closeModal = () => {
    this.setState({
      showCheckModal: false
    });
  };

  getCollegeInfo = async attributes => {
    const collegeName = attributes.collegeName.split("&")[0];
    const collegeId = await $util.getSchoolIdByName(collegeName);
    if (collegeId) {
      return Object.assign({}, attributes, { collegeId });
    }
  };

  handleSubmit = e => {
    this.setState({
      submitIsLoading: true
    });
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (!this.props.teamStore.currentTeamIsSpecialGame) {
          // UC和UL提交的时候不进行校验个人信息
          // 表单校验通过，进行用户个人信息校验。
          const verifyRes = await this.verify(values);
          if (!verifyRes) {
            this.setState({
              showCheckModal: true,
              submitIsLoading: false
            });
            return;
          }
        }
        // 当前是选择状态
        const attributes = {
          // 代表学校id
          collegeId: values.collegeId,
          // 学校所在地区，固定为空
          district: "",
          // 学校简称，固定为空
          collegeAbbreviation: "",
          // 学校名称，联队将学校名字用&拼接
          collegeName: values.delegateSchools ? values.delegateSchools.join("&") : "",
          // 校徽，固定为空
          collegeBadge: "",
          // 比赛id
          geventId: values.geventId,
          // 战队名
          name: values.name,
          // 战队类型
          teamType: values.teamType,
          // 收件地址
          consigneeAddress: values.consigneeAddress,
          // 收件人
          consigneeName: values.consigneeName,
          // 收件人联系方式
          consigneePhone: `${values.prefix.toString().indexOf("+") > -1 ? "" : "+"}${
            values.prefix
          } ${values.consigneePhone}`,
          // 收件地址国家code
          consigneeCountryCode: values.area[0] ? values.area[0] : "",
          // 收件地址省份code
          consigneeProvinceCode: values.area[1] ? values.area[1] : "",
          // 收件地址城市code
          consigneeCityCode: values.area[2] ? values.area[2] : "",
          // 收件地址地区code
          consigneeDistrictCode: values.area[3] ? values.area[3] : "",

          nameEn: values.nameEn,
          // 介绍链接
          campusOrganization: values.campusOrganization,
          // 战队口号
          teamSlogan: values.teamSlogan
        };

        // 如果填入的介绍链接包含http:// | https://那么直接提交，没有包含需要添加
        const introductionLinkOriginData = values.introductionLink || "";
        if (!introductionLinkOriginData) {
          attributes.introductionLink = "";
        } else if (
          introductionLinkOriginData.indexOf("https://") === 0 ||
          introductionLinkOriginData.indexOf("http://") === 0
        ) {
          attributes.introductionLink = introductionLinkOriginData;
        } else {
          attributes.introductionLink = `https://${introductionLinkOriginData}`;
        }
        try {
          const formattedAttributes = await this.getCollegeInfo(attributes);
          if (!formattedAttributes) throw new Error("通过学校名称获取学校id失败！！！");
          // 提交更新信息
          await this.props.teamStore.updateTeam({
            variables: {
              input: {
                id: values.id,
                attributes: formattedAttributes
              }
            }
          });
          this.setState({
            submitIsLoading: false
          });
          await message.success(
            this.props.languageStore.lang === "zh"
              ? "更新成功，3秒后返回。"
              : "Update success！Back to team center in 3 seconds.",
            3
          );
          this.props.navStore.changeNavigation("/control-center");
          this.props.history.push(`/team-apply/${values.id}`);
        } catch (error) {
          this.setState({
            submitIsLoading: false
          });
          message.error(
            this.props.languageStore.lang === "zh"
              ? "更新失败，请稍后重试。"
              : "Update failed, please try again later.",
            3
          );
        }
      } else {
        this.setState({
          submitIsLoading: false
        });
      }
    });
  };

  checkTeamName = (rule, value, callback) => {
    if (value) {
      value = value.trim();
      if (value.length < 1) {
        callback(<Language resource="INVALID_CHAR" />);
      }
      if ($util.countWordsLength(value) > 16) {
        callback(<Language resource="CHAR_LIMIT" />);
      }
      if (
        value.indexOf("队") > -1 ||
        value.indexOf("*") > -1 ||
        value.indexOf("/") > -1 ||
        value.indexOf("-") > -1 ||
        value.indexOf("+") > -1
      ) {
        callback(<Language resource="ILLEG_CHAR" />);
      }
    }
    callback();
  };

  validatePhone = (rule, value, callback) => {
    const prefix = this.props.form.getFieldValue("prefix");
    // if (!value) return callback(<Language resource="EMPTY_PHONE" /> )
    if (value) {
      if (prefix === "86" || prefix === "+86") {
        if (!$const.CHINA_PHONE.test(value)) callback(<Language resource="WRONG_PHONE" />);
        callback();
      } else {
        // 国际号码只做最短、最长校验
        if (!$const.FOREIGN_PHONE.test(value)) callback(<Language resource="WRONG_PHONE" />);
        callback();
      }
    }
    callback();
  };

  isStringLengthValid = input => {
    // 用于匹配英文标点的正则表达式
    // eslint-disable-next-line no-useless-escape
    const englishPunctuationRegex = /[.,\/#!$%\^&*;:{}=\-_`~()]/g;

    // 计算字符串长度
    let length = 0;

    // 遍历字符串的每个字符
    for (let char of input) {
      // 空格算1个字符
      if (char === " ") {
        length += 1;
      }
      // 匹配英文标点，每个算1个字符
      else if (englishPunctuationRegex.test(char)) {
        length += 1;
      } else {
        length += 2;
      }
    }

    // 返回是否不超过40个字符
    return length <= 40;
  };

  validateTeamSlogan = (rule, value, callback) => {
    if (value) {
      if (!this.isStringLengthValid(value)) {
        callback(<Language resource="WRONG_TEAM_SLOGAN" />);
      }
    }
    callback();
  };

  handleTeamTypeChange = value => {
    const delegateSchoolsO = this.props.form.getFieldValue("delegateSchools");
    this.props.form.setFieldsValue({
      delegateSchools: value === 1 ? delegateSchoolsO : delegateSchoolsO.slice(0, 1)
    });
  };

  render() {
    const lang = this.props.languageStore.lang;
    const isSpecialGame = this.props.isSpecialGame;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    // 当前比赛的赛事类型id
    const curGameCategoryId = `${this.props.gameStore.selectedGame.attributes.category_id}`;
    // 创建战队和修改战队资料页面展示介绍链接的赛事类型id
    const showIntroductionLinkGameCategoryId = `${this.props.gameStore.showIntroductionLinkGameCategoryId}`;
    // 是否需要填写战队口号
    const showTeamSloganInput = this.props.gameStore.showTeamSloganGameCategoryId.includes(
      curGameCategoryId
    );

    const { teamInfo } = this.state;
    const prefixSelector = getFieldDecorator(
      "prefix",
      {}
    )(
      <Select style={{ width: 100 }}>
        {$const.PHONE_PREFIX.map(item => {
          return <Option key={item} value={item}>{`+${item}`}</Option>;
        })}
      </Select>
    );
    const teamType = getFieldValue("teamType");
    // 国家
    let options = $const.COUNTRIES[lang];
    if (lang === "zh") {
      options[0].children = this.state.chinaArea;
    }
    //收件地址
    let recipientAddress = teamInfo
      ? [
          teamInfo.consigneeCountryCode,
          teamInfo.consigneeProvinceCode,
          teamInfo.consigneeCityCode,
          teamInfo.consigneeDistrictCode
        ]
      : [];

    return (
      <Form onSubmit={this.handleSubmit} className="create-team-form team-info-edit-form ">
        <div className="create-team" data-perf>
          <div className="title">
            <Language resource="EDIT_TEAM_INFO" />
          </div>
          <FormItem className="team-name-collegeId" style={{ display: "none" }}>
            {getFieldDecorator("collegeId", {})(<Input />)}
          </FormItem>
          <FormItem className="team-name-collegeId" style={{ display: "none" }}>
            {getFieldDecorator("collegeName", {})(<Input />)}
          </FormItem>
          <FormItem className="team-name-id" style={{ display: "none" }}>
            {getFieldDecorator("id", {})(<Input />)}
          </FormItem>
          <FormItem
            className="team-name-item"
            label={<Language resource="TEAM_NAME" />}
            extra={<Language resource="TEAM_NAME_TIP" />}
          >
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: <Language resource="PLEASE_ENTER_TEAM_NAME" />
                },
                {
                  validator: this.checkTeamName
                }
              ],
              initialValue: teamInfo ? teamInfo.name : ""
            })(<Input disabled={isSpecialGame} />)}
          </FormItem>
          {this.props.languageStore.lang === "zh" && (
            <FormItem
              className="team-name-item"
              label={<Language resource="TEAM_NAME_EN" />}
              extra={<Language resource="TEAM_NAME_EN_TIP" />}
            >
              {getFieldDecorator("nameEn", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="PLEASE_ENTER_TEAM_NAME_EN" />
                  },
                  {
                    validator: this.checkTeamName
                  }
                ],
                initialValue: teamInfo ? teamInfo.nameEn : ""
              })(<Input disabled={isSpecialGame} />)}
            </FormItem>
          )}
          <FormItem className="team-type-item">
            {getFieldDecorator("teamType", {
              rules: [{ required: true }],
              initialValue: teamInfo ? teamInfo.teamType : "",
              onChange: this.handleTeamTypeChange
            })(
              <Select disabled={isSpecialGame}>
                <Option value={$const.TEAM_TYPE.TEAM}>
                  <Language resource="TEAM" />
                </Option>
                <Option value={$const.TEAM_TYPE.CONSORTIUM}>
                  <Language resource="CONSORTIUM" />
                </Option>
              </Select>
            )}
          </FormItem>
          <FormItem label={<Language resource="ENTRY_PROJECT" />}>
            {getFieldDecorator("geventId", {
              rules: [
                {
                  required: true,
                  message: <Language resource="ENTRY_PROJECT_EMPTY_TIP" />
                }
              ]
            })(
              <Select disabled>
                <Option
                  key={this.props.gameStore.selectedGame.id}
                  value={this.props.gameStore.selectedGame.id}
                >
                  {this.props.gameStore.selectedGame.attributes.title}
                </Option>
              </Select>
            )}
          </FormItem>
          <FormItem
            label={<Language resource="TEAM_SCHOOL" />}
            className="team-info-edit-form__form-item-school"
          >
            {getFieldDecorator("delegateSchools", {
              rules: [
                {
                  required: true,
                  message: <Language resource="TEAM_SCHOOL_EMPTY_TIP" />
                }
              ]
            })(
              <SchoolsForm
                disabled={isSpecialGame}
                teamType={teamType}
                schoolsInfo={this.props.teamStore.schoolsInfo}
              />
            )}
          </FormItem>
          {!isSpecialGame ? (
            <FormItem
              className="team-name-item"
              label={<Language resource="CAMPUS_ORGANIZATION" />}
              extra={<Language resource="CAMPUS_ORGANIZATION_TIP" />}
            >
              {getFieldDecorator("campusOrganization", {
                rules: [
                  {
                    required: this.props.languageStore.lang === "zh",
                    message: <Language resource="PLEASE_ENTER_CAMPUS_ORGANIZATION" />
                  }
                ],
                initialValue: teamInfo ? teamInfo.campusOrganization : ""
              })(<Input />)}
            </FormItem>
          ) : null}
          {showTeamSloganInput ? (
            <FormItem
              className="team-name-item teamSlogan__formItem"
              label={
                <Row type="flex" align="middle" justify="start">
                  <Col style={{ marginRight: 8 }}>
                    <Language resource="TEAM_SLOGAN" />
                  </Col>
                  <Col>
                    <Tooltip title={<Language resource="TEAM_SLOGAN_TOOL_TIP_TEXT" />}>
                      <Icon type="exclamation-circle" />
                    </Tooltip>
                  </Col>
                </Row>
              }
              extra={<Language resource="TEAM_SLOGAN_TIPS" />}
            >
              {getFieldDecorator("teamSlogan", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="PLEASE_ENTER_TEAM_SLOGAN" />
                  },
                  {
                    validator: this.validateTeamSlogan
                  }
                ]
              })(<Input />)}
            </FormItem>
          ) : null}
          {curGameCategoryId === showIntroductionLinkGameCategoryId ? (
            <FormItem
              className="team-name-item"
              label={<Language resource="INTRODUCTION_LINKS" />}
              extra={<Language resource="INTRODUCTION_LINKS_TIP" />}
            >
              {getFieldDecorator("introductionLink", {
                rules: [{ required: false }]
              })(<Input />)}
            </FormItem>
          ) : null}
          <FormItem className="addressee" label={<Language resource="ADDRESSEE" />}>
            {getFieldDecorator("consigneeName", {
              rules: [
                {
                  required: true,
                  message: <Language resource="EMPTY_RECIPIENT" />
                }
              ],
              initialValue: teamInfo ? teamInfo.consigneeName : ""
            })(<Input />)}
          </FormItem>
          <FormItem label={<Language resource="ADDRESSEE_PHONE" />}>
            {getFieldDecorator("consigneePhone", {
              rules: [
                {
                  required: true,
                  message: <Language resource="EMPTY_PHONE" />
                },
                {
                  validator: this.validatePhone
                }
              ],
              initialValue: teamInfo ? teamInfo.consigneePhone : ""
            })(<Input addonBefore={prefixSelector} />)}
          </FormItem>
          <FormItem label={<Language resource="ADDRESSEE_ADRESS" />}>
            {getFieldDecorator("area", {
              rules: [
                {
                  required: true,
                  message: <Language resource="EMPTY_RECIPIENT" />
                }
              ],
              initialValue: recipientAddress
            })(
              <Cascader
                placeholder={this.props.languageStore.getResource(lang, "AREA")}
                options={options}
              />
            )}
          </FormItem>
          <FormItem className="emtpy-school-label" extra={<Language resource="ADDRESSEE_TIP" />}>
            {getFieldDecorator("consigneeAddress", {
              rules: [
                {
                  required: true,
                  message: <Language resource="EMPTY_ADDRESS" />
                }
              ],
              initialValue: teamInfo ? teamInfo.consigneeAddress : ""
            })(<Input />)}
          </FormItem>
          <FormItem className="submit">
            <Button loading={this.state.submitIsLoading} type="primary" htmlType="submit">
              <Language resource="UPDATE_TEAM" />
            </Button>
          </FormItem>
          <Modal
            title={<Language resource="PERSONAL_INFO_NOT_CHECKED" />}
            state={this.state.showCheckModal && this.state.checkErrorInfo.length > 0}
            close={this.closeModal}
            className="team-info-edit-form__modal-box"
          >
            <CheckErrorInfo checkErrorInfo={this.state.checkErrorInfo} />
            <Button
              className="team-info-edit-form__modal-btn"
              type="primary"
              htmlType="submit"
              onClick={this.closeModal}
            >
              <Language resource="CONFIRM" />
            </Button>
          </Modal>
        </div>
      </Form>
    );
  }
}

const TeamInfoEditForm = Form.create({
  mapPropsToFields(props) {
    return {
      id: Form.createFormField({
        value: props.teamInfo.id
      }),
      name: Form.createFormField({
        value: props.teamInfo.name
      }),
      teamType: Form.createFormField({
        value: props.teamInfo.teamType
      }),
      college: Form.createFormField({
        value:
          props.teamInfo.collegeId && props.teamInfo.college && props.teamInfo.college.name
            ? props.teamInfo.college.name
            : props.teamInfo.collegeName
      }),
      collegeId: Form.createFormField({
        value: props.teamInfo.collegeId
      }),
      collegeName: Form.createFormField({
        value: props.teamInfo.collegeName
      }),
      consigneeAddress: Form.createFormField({
        value: props.teamInfo.consigneeAddress
      }),
      consigneeName: Form.createFormField({
        value: props.teamInfo.consigneeName
      }),
      prefix: Form.createFormField({
        value: $util.formatPhone(props.teamInfo.consigneePhone)[0]
      }),
      consigneePhone: Form.createFormField({
        value: $util.formatPhone(props.teamInfo.consigneePhone)[1]
      }),
      geventId: Form.createFormField({
        value: props.teamInfo.eventId
      }),
      inviteCode: Form.createFormField({
        value: props.teamInfo.inviteCode
      }),
      district: Form.createFormField({
        value: props.teamInfo.district && props.teamInfo.district.split("-")
      }),
      collegeAbbreviation: Form.createFormField({
        value: props.teamInfo.collegeAbbreviation
      }),
      collegeBadge: Form.createFormField({
        value: props.teamInfo.collegeBadge
      }),
      consigneeCountryCode: Form.createFormField({
        value: props.teamInfo.consigneeCountryCode
      }),
      consigneeCityCode: Form.createFormField({
        value: props.teamInfo.consigneeCityCode
      }),
      consigneeDistrictCode: Form.createFormField({
        value: props.teamInfo.consigneeDistrictCode
      }),
      consigneeProvinceCode: Form.createFormField({
        value: props.teamInfo.consigneeProvinceCode
      }),
      introductionLink: Form.createFormField({
        value: props.teamInfo.introductionLink
      }),
      teamSlogan: Form.createFormField({
        value: props.teamInfo.teamSlogan
      })
    };
  }
})(TeamInfoEdit);
export default TeamInfoEditForm;



// WEBPACK FOOTER //
// ./src/components/createTeam/teamInfoEditForm.js